import { render } from "./EntryCarousel.vue?vue&type=template&id=3c1c9575&scoped=true"
import script from "./EntryCarousel.vue?vue&type=script&lang=ts"
export * from "./EntryCarousel.vue?vue&type=script&lang=ts"

import "./EntryCarousel.vue?vue&type=style&index=0&id=3c1c9575&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c1c9575"

export default script